<template>
    <div>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll">
            <v-row style="flex-wrap: nowrap">
                    <v-col cols="10" xs="8" sm="6" md="4" class="pa-1 ma-0"
                           v-for="postType in postTypes"
                           :key="postType.status"
                    >
                        <v-card class="blue-grey lighten-5 d-flex flex-column" height="100%">
                            <v-card-title class="ml-2 pa-1">
                                <v-list-item-title class="bold subtitle-1">
                                    {{postType.title}}
                                </v-list-item-title>
                            </v-card-title>
                            <div v-bind:style="[{height: (windowHeight - 160) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                                <div class="content">
                                    <v-card-text class="pa-0"
                                                 v-for="(post, index) in posts"
                                                 :key="post.id"
                                    >
                                        <post-card
                                                :status="post.status"
                                                v-if="post.status === postType.status || post.status === 'info'"
                                                :post="post"
                                                :index="index"
                                                @editMailing="editMailing(index)"
                                                @viewMailing="viewMailing(index)"
                                        ></post-card>
                                    </v-card-text>
                                </div>
                            </div>
                            <v-card-actions class="ma-0 pa-0">
                                <v-btn
                                        class="caption"
                                        block
                                        color="primary"
                                        text
                                        dark
                                        @click="createMailing"
                                        v-if="postType.status === 1"
                                >Создать пост</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
            </v-row>
        </v-container>
        <post-form
                :edit="postEditStatus"
                :mailings="posts"
                :index="indexEdit"
                :dialog="dialog"

                @close="dialog = false"
        ></post-form>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import PostForm from '../../components/bot/post/forms/PostForm'
import PostCard from '../../components/bot/post/cards/PostCard'
import { mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        PostForm,
        PostCard
    },
    data() {
        return {
            postEditStatus: true,
            dialog: false,
            indexEdit: null,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            postTypes: [
                {
                    title: 'В работе',
                    status: 1
                },
                {
                    title: 'Опубликованные',
                    status: 2
                },
                {
                    title: 'Ошибка в публикации',
                    status: 3
                }
            ],
            windowHeight: 0
        }
    },
    methods: {
        editMailing(index) {
            this.postEditStatus = true
            this.indexEdit = index
            this.dialog = true
        },
        viewMailing(index) {
            this.postEditStatus = false
            this.indexEdit = index
            this.dialog = true
        },
        createMailing() {
            if (this.bot(+this.$route.params['pathMatch']).token_vk !== '0') {
                this.postEditStatus = true
                this.dialog = true
            } else {
                this.paramsSnackbar.color = 'error'
                this.paramsSnackbar.text = 'Сначала нужно подключить токен в настройках!'
                this.snackbar = true
            }
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        this.$store.dispatch('posts/postAll', this.$route.params['pathMatch'])
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    watch: {
        dialog(value) {
            if (!value) { this.indexEdit = null }
        }
    },
    computed: {
        ...mapGetters({
            posts: 'posts/posts',
            bot: 'bots/getBotById',
            bots: 'bots/bots'
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
